import type { Item } from '@shared/types-v0.1.0';
// import type { Notification } from '../component/handleSubscribe'
import type { BaseProps, Props } from './definition';

export default (p: Props) =>
	({
		rootId: R.libs.nanoid(8),
		inited: false,
		signalsInited: false,
		fetchScheme: p.fetchScheme,
		controlled: p.controlled,
		subscribe: p.subscribe,
		paginationOn: p.paginationOn,
		paginationClass: p.paginationClass,
		toPageNumber: p.toPageNumber,
		page: 1,
		totalPagesCount: 0,
		from: 0,
		size: 0,
		hashForSchemes: {},
		schemesData: [],
		subscribes: [], // Массив подписок, чтобы мы могли отписаться при размонтировании
	} satisfies Store);

export type Store = BaseProps & {
	rootId: string;
	inited: boolean;
	signalsInited: boolean;
	schemesData: SchemeData[];
	subscribes: any[];
	page: number;
	totalPagesCount: number;
	from: number;
	size: number;
};

// Это массив, в котором хранятся схемы и itemsIds всех выполняемых схем для childrenFunc и recursionFunc
// для схемы 0 уровня и для каждого item и его дочерних
export type SchemeData = {
	scheme: FetchScheme; // Схема, по которой получались данные
	schemeHash?: string; // пока делаю опциональным, так как для rxdb он не нужен
	path: string; // idродительскогоitem.idдедовскогоitem.root
	level: number; // 2
	parentId?: string; // id родительского item
	itemIds: string[]; // id всхех найденных по схеме items
	fetched: number; // количество полученных
	total: number; // сколько всего, удовлетворяющих фильтру
};

export type FetchScheme = {
	dbName?: string;
	dbClass: string;
	order?: number;
	size?: number;
	from?: number;
	filters?: Record<string, unknown>;
	sorts?: { [path: string]: 'asc' | 'desc' }[];
	filtersFunc?: (data: Record<string, { items: Item[] }>) => Record<string, any> | undefined;
	childrenFunc?: (level: number, parentItem?: Item) => FetchScheme[] | undefined;
	recursionFunc?: (level: number, parentItem?: Item) => FetchScheme[] | undefined;
};
